<script setup>
import { RouterView } from 'vue-router'
import CookieConsentBanner from '@/components/CookieConsentBanner.vue'
</script>

<template>
  <RouterView />
  <CookieConsentBanner />
</template>
